
<template>
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      width="30%"
      @close="close"
      >
      <el-form ref="form" :model="form" :rules='rules' label-width="80px">
        <el-form-item label="品牌" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item class="bnt-bottom">
          <el-button type="primary" @click="validate('form')">保存</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
</template>
<script>
import { addBrand ,updateCarBrand} from '@/api/system'
export default {
  data() {
    return {
      dialogVisible:true,
      dialogName: this.$parent.dialogName,
      form: {
       name:'',
       id:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入品牌', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    if(this.$parent.childform.id){
      this.form.id = this.$parent.childform.id
      this.form.name =  this.$parent.childform.name 
    }
  },
  methods: {
    close(){
      this.$parent.dialogVisible = false
    },
    validate(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          return false
        }
      })
    },
   onSubmit(){
     if(this.form.id){
       this.updata()
       return
     }
      addBrand({name:this.form.name}).then(res=>{
        if(res.code===0){
          this.$message.success('新增成功')
          this.close()
          this.$emit('refresh')
        }
      })
    },
    updata(){
      updateCarBrand(this.form).then(res=>{
          this.$message.success('编辑成功')
          this.close()
          this.$emit('refresh')
      })
    }
  },
}
</script>

<style lang="less" scoped>
 /deep/.el-form{
    padding-right: 20px;
  }
.container {
  .bnt-bottom{
    /deep/ .el-form-item__content{
      width: 100%;
      text-align: center;
      margin-top: 10px;
      margin-left:0 !important;
    }
  }
}
</style>

